export const isDebug = window.location.pathname.indexOf('/app_dev.php') === 0;
